<div class="app-calendar-header">
    <button class="btn p-2" (click)="previousClicked('month')">
        <em class="arrow left"></em>
    </button>
    <span class="app-calendar-header-label">{{periodLabel}}</span>
    <button class="btn p-2" (click)="nextClicked('month')">
        <em class="arrow right"></em>
    </button>
</div>